export default {
  fields: {
    createdAt: 'Created',
    status: 'Status',
    enabled: 'Enabled',
    disabled: 'Disabled',
    name: 'Name',
    email: 'Email Address',
    phone: 'Phone',
    label_message: 'Message: ',
    label_description: 'Description: ',
    label_preview: 'Preview',
    created_by: 'Created by:',
    canceled_by: 'Canceled by:',
    terminated_by: 'Terminated by:',
    assigned_by: 'Assigned by:',
    rate_management: 'Rate Management',
    lastConnection: 'Last Connection',
    message: 'Message',
    duration: 'Duration',
    title: 'Title',
  },
  models: {
    users: 'User | Users',
    drivers: 'Driver | Drivers',
    drivers_connected: 'Connected Drivers'
  },
  actions: {
    submit: 'Submit',
    edit: 'Edit',
    close: 'Close',
    create: 'Create',
    delete: 'Delete',
    restart: 'Restart',
    cancel: 'Cancel',
    release: 'Release',
    assign: 'Assign',
    terminate: 'Terminate',
    filter: 'Filter',
    see: 'See',
    back: 'Back',
    copy_phone: 'Copy phone',
    clear_filters: 'Clear Filters',
    items_pages: 'Items per Pages',
    set_percentage: 'Set Percentage',
    send_message: 'Send Message',
    add: 'Add',
    claim_chat: 'Claim Chat',
    toggle_full: 'Full Mode',
  },
  messages: {
    updated: 'Resource updated successfully',
    created: 'Resource created successfully',
    deleted: 'Resource deleted successfully',
    error: 'Something went wrong!',
    waiting: 'Please wait ...',
    waitingSub: 'This will only take a moment',
    forbidden: 'Permission denied',
    error_chatBot: 'ChatBot and WhatsApp notification can\'t be enabled at time!',
    error_assistant: 'ChatBot and Assistant can\'t be enabled at time!',
    copied: 'Copied to clipboard',
    new_message: 'New message',
    chat_claimed_success: 'Chat claimed successfully',
    chat_claim_failed: 'Failed to claim chat. Please try again.',
    no_session_found: 'No Session Found',
    no_session_found_text: 'No active session found to claim for this chat',
  },
  placeholders: {
    optional: 'Optional',
    name: 'Enter name',
    email: 'Enter email',
    phone: 'Enter phone',
    phone2: 'Enter phone 2 (Optional)',
    password: 'Password',
    confirm_password: 'Confirm password',
    restore_password: 'Reset Password?',
    address: 'Enter Address',
    comment: 'Enter comment',
    search: 'Search',
    dark: 'Dark',
    light: 'Light',
    map: 'Map',
    all: 'All',
    device: 'Driver has not device registered',
    cancel_percent: 'Canceled index',
    weekly: 'Weekly',
    daily: 'Daily',
    daily_top_5: 'Top 5 daily',
    weekly_top_5: 'Top 5 weekly',
    monthly_top_5: 'Top 5 monthly',
    monthly_frequency: 'Monthly',
    top5_title: 'Top 5',
    top5_period_day: 'Day',
    top5_period_week: 'Wk.',
    top5_period_month: 'Mo.',
    top5_empty: 'No data',
    year_service_progress: 'Year service progress',
    first_place: 'First place',
    kpi_group_service: 'Service',
    kpi_group_revenue: 'Revenue',
    kpi_services_month: 'Services · month',
    kpi_completion_rate: 'Completion rate',
    kpi_cancellation_rate: 'Cancellation rate',
    kpi_leading_driver: 'Leading driver',
    kpi_leading_driver_empty: 'No services this month',
    kpi_services_unit: 'services',
    kpi_commission_income: 'Commission income',
    kpi_monthly_fee_income: 'Monthly-fee income',
    kpi_paying_drivers: 'paying drivers',
    kpi_cash_collected: 'Cash collected',
    kpi_recharges_count: 'recharges',
    income_by_charge_type: 'Income by charge type',
    income_breakdown: 'Monthly income breakdown',
    income_series_commission: 'Commission per service',
    income_series_monthly_fee: 'Fixed monthly fee',
    income_total: 'Total',
    service_info: 'Service information',
    route_info: 'Route and driver information',
    monthly: 'Monthly',
    percentage: 'Percentage',
    current_percentage: 'Current percentage',
    duration: 'Duration (in minutes)',
    description: {
      plate: 'Vehicle plate',
      vehicle_color: 'Vehicle Color',
      username: 'Name',
      company_number: 'Company Number',
      place_name: 'Place',
      company_name: 'Company Name',
    },
    label: {
      plate: 'Plate',
      color: 'Color',
      name: 'Name',
      number_pqr: 'PQR',
      place_name: 'Place',
      company_name: 'Company',
    },
    timeline: 'Timeline',
    canceled_by_section: 'Cancellation',
    no_destination: 'No destination',
  },
  filters: {
    title: 'Filters',
    from: 'From',
    until: 'Until',
    driver_plate: 'Driver\'s plate',
    number_client: 'Client\'s number',
    origin: 'Origin'
  },
  forms: {
    select_img: 'Choose image from files'
  },
  breadcrumb: {
    root: 'Pages'
  },
  chatBot: {
    connected: 'Connected',
    disconnected: 'Disconnected',
    disconnect: 'Disconnect',
    connect: 'Connect',
    reset: 'Reset'
  },
  colors: {
    black: 'Black',
    blue: 'Blue',
    gray: 'Gray',
    green: 'Green',
    purple: 'Purple',
    red: 'Red',
    white: 'White',
    pink: 'Pink',
    orange: 'Orange',
    gold: 'Gold',
    yellow: 'Yellow',
    magenta: 'Magenta',
    cyan: 'Cyan',
    brown: 'Brown',
    maroon: 'Maroon',
    beige: 'Beige',
    silver: 'Silver'
  },
  settings: {
    wpNotifications: 'WhatsApp Confirmations',
    chatBot: 'WhatsApp ChatBot',
    assistant: 'Assistant Bot',
    alert_notifications: 'Until confirmations are enabled won\'t send messages',
    alert_chatBot: 'Enable chatBot to completely manage WhatsApp messages',
    alert_assistant: 'Enable the assistant bot to create services when client send a location',
    agentInTrip: 'Agent In Trip',
    alert_agentInTrip: 'Requires ChatBot enabled. Keeps the agent answering after a driver is assigned',
    Ride_Fees: 'Ride Fees',
    Messages: 'Messages',
    fees_base_title: 'Base Fees',
    add_time_slot: 'Add Time Slot',
    price_kilometer: 'price for kilometer',
    price_minute: 'price for minute',
    fees_base: 'base fee',
    fees_additional: 'fee additional',
    fees_minimum: 'current fee for minimum',
    fees_minimum_day: 'Minimum fee for day',
    fees_minimum_nigth: 'Minimum fee for night',
    fees_minimum_festive: 'Minimum fee for festive day',
    fees_minimum_festive_nigth: 'Minimum fee for festive night',
    dynamic_min_fee: 'Dynamic min fee',
    dynamic_multiplier_fee: 'Dynamic multiplier fee',
    self_service_cancel_window_title: 'Self-Service Cancellation',
    self_service_cancel_window: 'Cancel window (seconds)',
    self_service_cancel_window_hint: 'Maximum time, in seconds, a driver has to cancel a self-service trip before the window expires.',
    hour_range: 'Time ranges',
    fees_night: 'fee of night',
    fees_DxF: 'Sundays and holidays',
    fees_night_DxF: 'Sundays and night holidays',
    general_settings: 'General Settings',
    cities: 'Cities',
    currency_code: 'Currency code',
    calling_code: 'Calling code',
    branches: 'Branches',
  },
  titles: {
    title_modal: 'Edit WhatsApp Messages',
    title_card: 'WhatsApp Message Table'
  },
  errors: {
    invalid_duration: 'Invalid duration min 1 minutes',
  },
  paginator: {
    summary: 'Showing {from}–{to} of {total}',
    empty: 'No drivers match the current filters',
    go_to_page: 'Go to page',
    per_page: 'Items per page',
  }
}